import type { ApolloClientOptions } from '@apollo/client'
import { InMemoryCache } from '@apollo/client/core'

export const sharedClientOptions: ApolloClientOptions<object> = {
  cache: new InMemoryCache(),
  ssrMode: false
}
